import ErrorHandler from "../error-handlers/axios/defaultErrorHandler";

/**
 * Fetches aggregated hot lead funnel data for all agents or teams
 * 
 * @param {Object} axiosInstance - Axios instance with authentication
 * @param {Object} options - Request options
 * @param {Object} options.params - Query parameters
 * @param {string} options.params.period - Time period ('daily', 'weekly', 'monthly')
 * @param {string} options.params.startDate - Start date in ISO format
 * @param {string} options.params.endDate - End date in ISO format
 * @param {string} options.params.teamId - Optional team ID to filter by
 * @returns {Promise<Object>} - Aggregated hot lead funnel data with the following structure:
 * {
 *   period: string,
 *   startDate: string,
 *   endDate: string,
 *   hotLeadsAssigned: number,
 *   hotLeadsFollowedUp: number,
 *   hotLeadsConverted: number,
 *   hotLeadsListingDeals: number,
 *   hotLeadsWon: number,
 *   hotLeadConversionRate: number,
 *   hotLeadDropOffRate: number,
 *   hotLeadSourceMetrics: {
 *     [sourceName: string]: {
 *       leadsAssigned: number,
 *       leadsFollowedUp: number,
 *       leadsConverted: number,
 *       listingDeals: number,
 *       leadsWon: number,
 *       conversionRate: number,
 *       dropOffRate: number
 *     }
 *   }
 * }
 */
export const getAllHotLeadFunnel = async (axiosInstance, options = {}) => {
  try {
    const res = await axiosInstance.get('/agent-performance/hot-lead-funnel', options);
    return res?.data;
  } catch (error) {
    ErrorHandler.handle(error);
    return {
      period: "monthly",
      startDate: "",
      endDate: "",
      hotLeadsAssigned: 0,
      hotLeadsFollowedUp: 0,
      hotLeadsConverted: 0,
      hotLeadsListingDeals: 0,
      hotLeadsWon: 0,
      hotLeadConversionRate: 0,
      hotLeadDropOffRate: 0,
      hotLeadSourceMetrics: {},
      error: true
    };
  }
};
